import {
    SET_CHECKOUT_HEADER_OPTIONS
} from '../middleware/types'

const initialState = {
    SUBMIT_loading: false,
    error: {},
    showDelivery: true

}

 const CheckOutHeaderOptionsReducer = (state = initialState, action) => {
    console.log('action...', action);
    switch (action.type) {
        case SET_CHECKOUT_HEADER_OPTIONS:
            return {
                ...state,
                SUBMIT_loading: false,
                showDelivery: action.showDelivery,
                
            }
        default:
            return state
    }
}

export default CheckOutHeaderOptionsReducer